/* import __COLOCATED_TEMPLATE__ from './legend-item.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();